import Parent from "parentjs/controllers/home_campaigns_controller.js";
export default Parent;
